module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAICAMAAADHqI+lAAAARVBMVEUAAADMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMx7eaEzAAAAFnRSTlMA+e1eFeDZy7CZkIJ1VEM5KyMLA7u65ppSnwAAAE5JREFUCNdNjEcKwDAQA7e495Ls/58ajDGxLsMgJNiZIUy4MpyIG78rK96LVceblgSQRLfthTAvZqSyyEh1N5WQAaKYfrbdSAR+1PX+8geoSAJqu+k2kQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/view/shopping/images/ic_index_up.png
// module id = /bgY
// module chunks = 21